import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SoepPage from "./pages/SoepPage";
import DocumentationPage from "./pages/DocumentationPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import UserSettingsPage from "./pages/UserSettingsPage";
import UserManualPage from "./pages/UserManualPage";
import PatientSharePage from "./pages/PatientSharePage";
import LiveTranscriptPage from "./pages/LiveTranscriptPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
           <Route path="/" element={<SoepPage />} />
           <Route path="/soep" element={<SoepPage />} />
           <Route path="/settings" element={<UserSettingsPage />} />
           <Route path="/handleiding" element={<UserManualPage />} />
           <Route path="/patient-share/:token" element={<PatientSharePage />} />
           <Route path="/live/:token" element={<LiveTranscriptPage />} />
           <Route path="/admin/login" element={<AdminLoginPage />} />
           <Route path="/admin" element={<AdminSettingsPage />} />
           <Route path="/admin/docs" element={<DocumentationPage />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
